<template>
    <b-modal id="builtinModal" class="cx_modal" v-model="showAlert" centered :title="alertTitle" :ok-only="okOnly" @ok="onOk" @cancel="onCancel" @shown="onShown" :return-focus="return_focus" :no-close-on-backdrop="true" :ok-title="okTitle" :cancel-title="cancelTitle" :html="html">
        <span class="cx_modal_message">{{alertMessage}}</span>
        <span v-for="(modalLink, index) in links" :key="index" :data-item-id="index" class="cx_link_item" @click="onClick(modalLink.link, modalLink.isExternalLink)">{{modalLink.text}}</span>    
    </b-modal>
</template>

<script lang="ts">
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import * as Common from '@/agiles/common';

@Component
export default class Modal extends Vue {
  public showAlert: boolean = false;
  public alertTitle: string = '';
  public alertMessage: string = '';
  public html: string ='';
  public okOnly: boolean = false;
  public okTitle: string = '';
  public cancelTitle: string = '';
  public exec: () => void = () => {}; //ダミー
  public cancel:()=> void = ()=>{};
  public links:Common.ModalLink[] = [];
  public return_focus: any = null;
  public onOk(){
     if (this.exec) this.exec();
      this.showAlert = false;
  }
  public onCancel(){
      this.cancel();      
      this.showAlert = false;
  }  
  public updated(){
      this.return_focus = document.activeElement;
  }
  public onShown(){
          
              var el = document.getElementById('builtinModal___BV_modal_footer_');
              // (el.childNodes[1] as HTMLButtonElement).autofocus = true;
              (el.childNodes[1] as HTMLElement).focus();

  }

  public onClick(link:string, isExternalLink:boolean){
      this.showAlert = false;
      if(isExternalLink == true) window.open(link);
      else this.$router.push(link);
  }

}
</script>
<style lang="scss">
    .cx_modal{

        .modal-body{
            display: flex;
            flex-direction: column;
            align-items: center;     
        }
        span {
            // display: block;            
            text-align: left;
            white-space: pre-line;            
        }
        .cx_modal_message{
            margin-bottom: 10px;
        }
    }
</style>